module.exports = __webpack_public_path__ + "assets/img/mecha-dad708c9.png";